export default __webpack_public_path__ + "static/media/logo-cocel-medium.5c661299.png";